import { Controller } from "@hotwired/stimulus"

// Shows and hides one panel from a button: a subdivision's bedroom rows on
// its area's page. The button carries aria-expanded; the chevron turns over.
export default class extends Controller {
  static targets = ["button", "panel", "icon"]

  toggle() {
    const open = this.panelTarget.hidden
    this.panelTarget.hidden = !open
    this.buttonTarget.setAttribute("aria-expanded", String(open))
    if (this.hasIconTarget) this.iconTarget.classList.toggle("rotate-180", open)
  }
}
